"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbedInsightDialogBase = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var copy_to_clipboard_1 = tslib_1.__importDefault(require("copy-to-clipboard"));
var react_intl_1 = require("react-intl");
var CodeArea_1 = require("./components/CodeArea");
var ConfirmDialogBase_1 = require("../../ConfirmDialogBase");
var PrepareEnvMessage_1 = require("./components/PrepareEnvMessage");
var CodeLanguageSelect_1 = require("./components/CodeLanguageSelect");
var CodeOptions_1 = require("./components/CodeOptions");
var CompleteListPropsMessage_1 = require("./components/CompleteListPropsMessage");
var Bubble_1 = require("../../../Bubble");
var locales_1 = require("../../../locales");
var HEADER_TOOLTIP_ALIGN_POINTS = [{ align: "bc tl" }];
var HEADER_TOOLTIP_ARROW_OFFSETS = { "bc tl": [-7, 0] };
/**
 * @internal
 */
exports.EmbedInsightDialogBase = function (props) {
    var code = props.code, codeLanguage = props.codeLanguage, codeOption = props.codeOption, propertiesLink = props.propertiesLink, integrationDocLink = props.integrationDocLink, onClose = props.onClose, onCopyCode = props.onCopyCode, onCodeLanguageChange = props.onCodeLanguageChange, onCodeOptionChange = props.onCodeOptionChange;
    var intl = react_intl_1.useIntl();
    var onCopyButtonClick = react_1.useCallback(function () {
        copy_to_clipboard_1.default(code);
        onCopyCode(code, "button");
    }, [code, onCopyCode]);
    var onAreaCopy = react_1.useCallback(function () {
        copy_to_clipboard_1.default(code);
        onCopyCode(code, "keyboard");
    }, [code, onCopyCode]);
    return (react_1.default.createElement(ConfirmDialogBase_1.ConfirmDialogBase, { isPositive: true, onClose: onClose, onCancel: onClose, onSubmit: onCopyButtonClick, cancelButtonText: intl.formatMessage({ id: "embedInsightDialog.actions.close" }), submitButtonText: intl.formatMessage({ id: "embedInsightDialog.actions.copyCode" }), headline: intl.formatMessage({ id: getDialogLabelId(codeOption.type) }), className: classnames_1.default("embed-insight-dialog", "s-embed-insight-dialog"), dialogHeaderClassName: "embed-insight-dialog-header", footerLeftRenderer: propertiesLink
            ? function () {
                return (react_1.default.createElement("div", { className: "embed-insight-dialog-left-footer-renderer" },
                    react_1.default.createElement(CompleteListPropsMessage_1.CompleteListPropsMessage, { documentationLink: propertiesLink })));
            }
            : undefined, titleRightIconRenderer: function () { return (react_1.default.createElement(Bubble_1.BubbleHoverTrigger, { className: "gd-button", showDelay: 0, hideDelay: 0 },
            react_1.default.createElement("span", { className: "gd-icon-circle-question s-circle_question-dialog-title question-mark-icon embed-insight-dialog-header-icon" }),
            react_1.default.createElement(Bubble_1.Bubble, { className: "bubble-primary", alignPoints: HEADER_TOOLTIP_ALIGN_POINTS, arrowOffsets: HEADER_TOOLTIP_ARROW_OFFSETS },
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: getChangesLabelId(codeOption.type) })))); } },
        react_1.default.createElement("div", { className: "embed-insight-dialog-content" },
            react_1.default.createElement(PrepareEnvMessage_1.PrepareEnvMessage, { integrationDocLink: integrationDocLink }),
            react_1.default.createElement("div", { className: "embed-insight-dialog-code" },
                react_1.default.createElement("div", { className: "embed-insight-dialog-code-settings" },
                    react_1.default.createElement(CodeLanguageSelect_1.CodeLanguageSelect, { selectedLanguage: codeLanguage, onLanguageChanged: onCodeLanguageChange }),
                    react_1.default.createElement(CodeOptions_1.CodeOptions, { option: codeOption, onChange: onCodeOptionChange })),
                react_1.default.createElement("div", { className: "embed-insight-dialog-code-wrapper" },
                    react_1.default.createElement(CodeArea_1.CodeArea, { code: code, onCopyCode: onAreaCopy }))))));
};
var getDialogLabelId = function (codeType) {
    return locales_1.dialogHeadlineLabels[codeType].id;
};
var getChangesLabelId = function (codeType) {
    return locales_1.dialogChangeMessageLabels[codeType].id;
};
//# sourceMappingURL=EmbedInsightDialogBase.js.map